export default "__VITE_ASSET__DW6WwdEx__"